import React from 'react';
import {Input} from '../UI';

export const Representative = () => {
  return (
    <div className='space-y-4'>
      <div className='grid grid-cols-2 gap-6'>
        <Input name='representative.name' label='Sierra Representative' />
        <Input name='representative.title' label='Title' />
      </div>
    </div>
  );
};